var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import moment from 'moment';
import { container } from 'tsyringe';
import { EntityBuilder } from '@decahedron/entity';
import { TalentComment } from 'packages/talent/entities/TalentComment';
import { CommentRepository } from 'packages/talent/CommentRepository';
import { User } from 'packages/users/User';
export var actions = {
    getComments: function (_a, _b) {
        var commit = _a.commit;
        var talentId = _b.talentId, jobId = _b.jobId;
        return __awaiter(this, void 0, void 0, function () {
            var repo, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        repo = container.resolve(CommentRepository);
                        commit('setComments', []);
                        commit('setLoading', true);
                        _c = commit;
                        _d = ['setComments'];
                        return [4 /*yield*/, repo.getComments(talentId, jobId)];
                    case 1:
                        _c.apply(void 0, _d.concat([_e.sent()]));
                        commit('setLoading', false);
                        return [2 /*return*/];
                }
            });
        });
    },
    getCommenters: function (_a, _b) {
        var commit = _a.commit;
        var talentId = _b.talentId, jobId = _b.jobId;
        return __awaiter(this, void 0, void 0, function () {
            var repo, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        repo = container.resolve(CommentRepository);
                        commit('setCommenters', []);
                        commit('setLoading', true);
                        _c = commit;
                        _d = ['setCommenters'];
                        return [4 /*yield*/, repo.getCommenters(talentId, jobId)];
                    case 1:
                        _c.apply(void 0, _d.concat([_e.sent()]));
                        commit('setLoading', false);
                        return [2 /*return*/];
                }
            });
        });
    },
    postComment: function (_a, _b) {
        var commit = _a.commit, rootState = _a.rootState;
        var talentId = _b.talentId, body = _b.body, jobId = _b.jobId;
        return __awaiter(this, void 0, void 0, function () {
            var repo, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        repo = container.resolve(CommentRepository);
                        commit('setLoading', true);
                        return [4 /*yield*/, repo.postComment(talentId, body, jobId)];
                    case 1:
                        _e.sent();
                        commit('addComment', EntityBuilder.buildOne(TalentComment, {
                            talentId: talentId,
                            body: body,
                            author: rootState.profile.user.id,
                            createdAt: moment().format(),
                        }));
                        commit('addCommenter', EntityBuilder.buildOne(User, rootState.profile.user));
                        _c = commit;
                        _d = ['setComments'];
                        return [4 /*yield*/, repo.getComments(talentId, jobId)];
                    case 2:
                        _c.apply(void 0, _d.concat([_e.sent()]));
                        commit('setLoading', false);
                        return [2 /*return*/];
                }
            });
        });
    },
    editComment: function (_a, _b) {
        var commit = _a.commit;
        var talentId = _b.talentId, body = _b.body, commentId = _b.commentId, jobId = _b.jobId;
        return __awaiter(this, void 0, void 0, function () {
            var repo, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        repo = container.resolve(CommentRepository);
                        commit('setLoading', true);
                        return [4 /*yield*/, repo.updateComment(body, commentId)];
                    case 1:
                        _e.sent();
                        _c = commit;
                        _d = ['setComments'];
                        return [4 /*yield*/, repo.getComments(talentId, jobId)];
                    case 2:
                        _c.apply(void 0, _d.concat([_e.sent()]));
                        commit('setLoading', false);
                        return [2 /*return*/];
                }
            });
        });
    },
    deleteComment: function (_a, _b) {
        var commit = _a.commit;
        var talentId = _b.talentId, commentId = _b.commentId, jobId = _b.jobId;
        return __awaiter(this, void 0, void 0, function () {
            var repo, _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        repo = container.resolve(CommentRepository);
                        commit('setLoading', true);
                        return [4 /*yield*/, repo.deleteComment(commentId)];
                    case 1:
                        _g.sent();
                        _c = commit;
                        _d = ['setComments'];
                        return [4 /*yield*/, repo.getComments(talentId, jobId)];
                    case 2:
                        _c.apply(void 0, _d.concat([_g.sent()]));
                        _e = commit;
                        _f = ['setCommenters'];
                        return [4 /*yield*/, repo.getCommenters(talentId, jobId)];
                    case 3:
                        _e.apply(void 0, _f.concat([_g.sent()]));
                        commit('setLoading', false);
                        return [2 /*return*/];
                }
            });
        });
    },
};
